import { ConfirmButton } from "@/components/common/ConfirmButton";
import { CopyIconButton } from "@/components/common/CopyIconButton";

interface RecoveryCodesPanelProps {
	codes: string[];
	onDone: () => void;
	doneLabel?: string;
}

/** 発行したリカバリーコードを一度だけ見せる。画面を閉じると二度と表示できないため、保存を促す。 */
export function RecoveryCodesPanel({
	codes,
	onDone,
	doneLabel = "保存しました",
}: RecoveryCodesPanelProps) {
	const text = codes.join("\n");

	function download() {
		const url = URL.createObjectURL(new Blob([`${text}\n`], { type: "text/plain" }));
		const link = document.createElement("a");
		link.href = url;
		link.download = "izanagi-recovery-codes.txt";
		link.click();
		URL.revokeObjectURL(url);
	}

	return (
		<div data-testid="recovery-codes" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
			<p
				style={{
					margin: 0,
					fontSize: "var(--text-ui)",
					color: "var(--fg-2)",
					lineHeight: "var(--leading-body)",
				}}
			>
				認証アプリやパスキーを使えなくなったときは、このリカバリーコードでサインインできます。各コードは
				1
				回だけ使えます。この画面を閉じると再表示できないため、パスワードマネージャーなど安全な場所に保存してください。
			</p>
			<div
				style={{
					position: "relative",
					display: "grid",
					gridTemplateColumns: "repeat(2, 1fr)",
					gap: "6px 24px",
					padding: "12px 16px",
					borderRadius: "var(--radius-3)",
					background: "var(--surface-2)",
					boxShadow: "var(--shadow-ring)",
				}}
			>
				{codes.map((code) => (
					<code
						key={code}
						className="select-text"
						style={{
							fontFamily: "var(--font-mono)",
							fontSize: "var(--text-ui)",
							color: "var(--fg-1)",
						}}
					>
						{code}
					</code>
				))}
				<div style={{ position: "absolute", top: 8, right: 8 }}>
					<CopyIconButton value={text} label="すべてコピー" />
				</div>
			</div>
			<div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
				<ConfirmButton
					label="ダウンロード"
					variant="secondary"
					loading={false}
					onClick={download}
				/>
				<ConfirmButton
					label={doneLabel}
					loading={false}
					onClick={onDone}
					data-testid="recovery-codes-done"
				/>
			</div>
		</div>
	);
}
